import type {
    FC
} from "react";
import type IProgressTitleProps from "./type";
import stylesheet from "./stylesheet";
import type {
    ProgressPartContentProps
} from "../../type";
import {
    withProgressContext
} from "../../context";
import Text from "../../../text";

const ProgressTitleContent: FC<ProgressPartContentProps<IProgressTitleProps>> = ({
    customTheme: customThemeProp,
    children,
    context,
    style,
    ...props
}) => {
    const content = children ?? context.title;

    if(!content) {
        return null;
    }

    return <Text
        {...props}
        customTheme={customThemeProp ?? context.customTheme}
        customColor={context.currentColors.titleColor}
        variant={context.currentSize.labelVariant}
        style={[
            style,
            stylesheet.title
        ]}
        id={context.titleID}
        numberOfLines={1}
    >
        {content}
    </Text>;
};
export default withProgressContext("Title", ProgressTitleContent);
